import type { ProductLaunchView } from "@/modules/membership/domain/repo/product-launches-repo";
import type { MenuCatalogProductOption } from "@/modules/membership/domain/repo/list-menu-catalog-options";
import type { MembershipSettingsView } from "@/modules/membership/domain/types";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

const base = `${config.apiUrl}/membership`;

export const membershipApi = {
  getSettings: (): Promise<MembershipSettingsView> =>
    fetcher.get<MembershipSettingsView>(`${base}/settings`),

  updateSettings: (
    payload: Partial<MembershipSettingsView>,
  ): Promise<MembershipSettingsView> =>
    fetcher.put<MembershipSettingsView>(`${base}/settings`, payload),

  getEligibleMenuOptions: (): Promise<{ products: MenuCatalogProductOption[] }> =>
    fetcher.get<{ products: MenuCatalogProductOption[] }>(
      `${base}/eligible-menu-options`,
    ),

  listProductLaunches: (variantIds?: string[]): Promise<{ launches: ProductLaunchView[] }> => {
    const query = variantIds?.length
      ? `?${variantIds.map((id) => `variantId=${encodeURIComponent(id)}`).join("&")}`
      : "";
    return fetcher.get<{ launches: ProductLaunchView[] }>(
      `${base}/product-launches${query}`,
    );
  },

  upsertProductLaunch: (
    variantId: string,
    payload: { goldFreeEnabled: boolean; launchAt?: string },
  ): Promise<ProductLaunchView> =>
    fetcher.put<ProductLaunchView>(
      `${base}/product-launches/${variantId}`,
      payload,
    ),
};
